"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GnosisSafeProxyFactoryEthersContract_1 = __importDefault(require("../GnosisSafeProxyFactoryEthersContract"));
class GnosisSafeProxyFactoryContract_V1_1_1_Ethers extends GnosisSafeProxyFactoryEthersContract_1.default {
    constructor(contract) {
        super(contract);
        this.contract = contract;
    }
}
exports.default = GnosisSafeProxyFactoryContract_V1_1_1_Ethers;
//# sourceMappingURL=GnosisSafeProxyFactoryContract_V1_1_1_Ethers.js.map